// BillingCompany API
import {
    RequestConfigFunction,
} from 'app/types/request.types'

type BillingCompanyRequests = {
    domainName: string,
    get: RequestConfigFunction<{id: number}>,
    filterRequest: RequestConfigFunction<{ params?: Record<string, any>}>,
    create: RequestConfigFunction,
    update: RequestConfigFunction<{id: number}>,
    archive: RequestConfigFunction<{id: number}>,
    restore: RequestConfigFunction<{id: number}>,
    billingCompanyChangeSummary: {
        name: string,
        request: (id: number) => {
            customUrl: string,
            method: string,
            name: string,
        }
    },
    customerSalesArea: RequestConfigFunction<{id: number}>,
    communication: RequestConfigFunction<{id: number}>,
    salesAreaTax: RequestConfigFunction<{id: number}>,
    abacus: RequestConfigFunction<{id: number}>,
}

const billingCompanyRequests: BillingCompanyRequests = {
    domainName: 'BillingCompanyDto',
    get: ({
        id,
    }) => {
        return {
            url: `billingcompany/${id}`,
            method: 'GET',
        }
    },
    filterRequest: ({
        params = {},
    } = {}) => {
        return {
            url: 'billingcompany/filter-request/all',
            method: 'POST',
            ...params,
        }
    },
    create: () => {
        return {
            url: 'billingcompany',
            method: 'POST',
        }
    },
    update: ({
        id,
    }) => {
        return {
            url: `billingcompany/${id}/data`,
            method: 'PATCH',
        }
    },
    archive: ({
        id,
    }) => {
        return {
            url: `billingcompany/${id}/archive`,
            method: 'PATCH',
        }
    },
    restore: ({
        id,
    }) => {
        return {
            url: `billingcompany/${id}/restore`,
            method: 'PATCH',
        }
    },
    billingCompanyChangeSummary: {
        name: 'Modification',
        request: (billingCompanyNumber) => {
            return {
                customUrl: `billingcompany/${billingCompanyNumber}/modifications`,
                method: 'GET',
                name: 'BillingCompany',
            }
        },
    },
    customerSalesArea: ({
        id,
    }) => {
        return {
            url: `billingcompany/${id}/customer-sales-area-data`,
            method: 'PATCH',
        }
    },
    communication: ({
        id,
    }) => {
        return {
            url: `billingcompany/${id}/communication-data`,
            method: 'PATCH',
        }
    },
    salesAreaTax: ({
        id,
    }) => {
        return {
            url: `billingcompany/${id}/sales-area-tax-data`,
            method: 'PATCH',
        }
    },
    abacus: ({
        id,
    }) => {
        return {
            url: `billingcompany/${id}/abacus-data`,
            method: 'PATCH',
        }
    },
}

export default billingCompanyRequests
